import { createHttpEndpoint } from '../../utils'

import type {
  GetNextTaskResponse,
  GetRequestsResponse,
  OrderlineRequest,
  getInvoiceResponse,
} from './types/requests.types'

/**
 * Retrieve requests on Customer Care page
 *
 * @see {@link  https://devportal.backmarket.io/catalog/default/api/seller-after-sales-api/definition#/Request/get-requests}
 */

export const getRequests = createHttpEndpoint<GetRequestsResponse>({
  method: 'GET',
  operationId: 'getSellerRequests',
  path: '/seller-after-sales/api/v1/requests',
})

/**
 * Retrieve the next task
 *
 * @see {@link  https://devportal.backmarket.io/catalog/default/api/seller-after-sales-api/definition#/Request/get-orderline-requests}
 */

export const getOrderlineRequests = createHttpEndpoint<OrderlineRequest[]>({
  method: 'GET',
  operationId: 'getOrderlineRequests',
  path: '/seller-after-sales/api/v1/orderlines/:orderlineId/requests',
})

/**
 * Retrieve the next task
 *
 * @see {@link  https://devportal.backmarket.io/catalog/default/api/seller-after-sales-api/definition#/Task/get-next-task}
 */

export const getNextTask = createHttpEndpoint<GetNextTaskResponse>({
  method: 'GET',
  operationId: 'getNextTask',
  path: '/seller-after-sales/api/v1/tasks/:taskId/next',
})

/**
 * Upload seller invoice on Customer Care page
 */
export const provideCustomerRequestPlatformInvoiceV2 =
  createHttpEndpoint<getInvoiceResponse>({
    method: 'POST',
    operationId: 'provideCustomerRequestPlatformInvoiceV2',
    path: '/bm/customer_request/orders/:orderId/merchant/invoice-v2',
  })
